'use strict'

const fitAnalyticsHelper = require('./fitAnalyticsHelper')

function getCookieConsents() {
    const allCookies = document.cookie.split(';').map(c => c.trim());
    let status = 'Opt Out';
    let isOneTrustAccepted = false;

    allCookies.forEach(cookieStr => {
        const [name, ...rest] = cookieStr.split('=');
        const value = rest.join('=');

        if (name.trim() === "OptanonConsent") {
            try {
                const decodedValue = decodeURIComponent(value);
                const match = decodedValue.match(/groups=([^&]+)/);
                if (match) {
                    const groups = match[1].split(',');
                    const c0004 = groups.find(g => g.startsWith('C0004:'));
                    if (c0004 && c0004.endsWith(':1')) {
                        status = 'Opt In';
                        isOneTrustAccepted = true;
                    }
                }
            } catch (e) {
                log('Error during cookie parsing: ', e);
            }
        }
    });

    return isOneTrustAccepted;
}

function getCurrentSize() {
    return $('.js-size-attribute.cc-available').find('.selected').attr('data-attr-value');
}

function getCartItems() {
    let getCartItemsUrl = $('.js-fit-analytics').attr('data-get-cart-items');

    return new Promise(function (resolve, reject) {
        $.ajax({
            url: getCartItemsUrl,
            method: 'GET',
            success: function (data) {
                if (data && data.cartItems) {
                    resolve(data.cartItems);
                } else {
                    resolve({});
                }
            },
            error: function (err) {
                console.error('Error:', err);
                $.spinner().stop();
                reject(err);
            }
        });
    });
}

// Call this function inside "selectAttribute" function to update FitAnalytics context data object
function updatePdpDataObject() {

    let getProductDataUrl = $('.js-fit-analytics').attr('data-get-product');
    if(getProductDataUrl){
        let variantId = $('#product-id-sku').text();
        let context = 'pdp';
    
        // Add or update the query parameters
        let url = new URL(getProductDataUrl, window.location.origin);
        url.searchParams.set('variantId', variantId);
        url.searchParams.set('context', context);
        getProductDataUrl = url.toString();
    
        $.ajax({
            url: getProductDataUrl,
            method: 'GET',
            success: function (data) {
                if (data && data.dataObject) {
                    window.fitAnalyticsData = data.dataObject;
                    window.fitAnalyticsData.consent = { hasAnalyticsConsent() { return getCookieConsents() } };
                    window.fitAnalyticsData.operations = {
                        getAddToCartBtn: function () { return document.querySelector('.add-to-cart') },
                        getSizeChartLink: function () { return document.querySelector('.btn-sizeguide') },
                        addToCart: function (currentItemSubgroupId, size) { return addToCart(currentItemSubgroupId, size) },
                        selectSize: function (currentItemSubgroupId, size) { return selectSize(currentItemSubgroupId, size) },
                        getCartItems: function () { return getCartItems() }
                    }
                }
            },
            error: function (err) {
                console.error('Error:', err);
                $.spinner().stop();
            }
        });
    }
    
}

function addToCart(itemSubgroupId, size) {
    let $this = $('button.button.add-to-cart');
    let addToCartUrl;
    let pid;
    let pidsObj;
    let setPids;

    $('body').trigger('product:beforeAddToCart', $this);

    if ($('.set-items').length && $this.hasClass('add-to-cart-global')) {
        setPids = [];

        $('.product-detail').each(function () {
            if (!$this.hasClass('product-set-detail') && !$this.hasClass('product-tile')) {
                setPids.push({
                    pid: $this.find('.product-id').text(),
                    qty: $this.find('.quantity-select').val(),
                    options: getOptions($this)
                });
            }
        });
        pidsObj = JSON.stringify(setPids);
    }

    pid = fitAnalyticsHelper.getPidValue(itemSubgroupId, size);

    let $productContainer = $this.closest('.product-detail');
    if (!$productContainer.length) {
        $productContainer = $this.closest('.quick-view-dialog').find('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $this.closest('.js-product-card-wishlist');
        }
    }

    addToCartUrl = fitAnalyticsHelper.getAddToCartUrl();

    let quantity = '';
    if ($this.parents('.cc-quickview__addtobutton-wrap')) {
        quantity = 1;
    } else {
        quantity = fitAnalyticsHelper.getQuantitySelected($this);
    }
    let form = {
        pid: pid,
        pidsObj: pidsObj,
        childProducts: fitAnalyticsHelper.getChildProducts(),
        quantity: quantity
    };

    if (!$('.bundle-item').length) {
        form.options = fitAnalyticsHelper.getOptions($productContainer);
    }

    $this.trigger('updateAddToCartFormData', form);
    if (addToCartUrl) {
        $.ajax({
            url: addToCartUrl,
            method: 'POST',
            data: form,
            success: function (data) {
                fitAnalyticsHelper.handlePostCartAdd(data);
                $('body').trigger('product:afterAddToCart', data);
                $.spinner().stop();
                fitAnalyticsHelper.miniCartReportingUrl(data.reportingURL);

            },
            error: function (err) {
                console.error(err);
                $.spinner().stop();
            }
        });
    }
}

function selectSize(itemSubgroupId, size) {

    // If variant is already selected, exit from function
    let selectedColor = $(`[data-attr-value="${itemSubgroupId}"]`);
    let selectedSize = $(`[data-display-value="${size}"]`).find('.selected');
    if(selectedColor.hasClass('selected') && selectedSize.length > 0){
        return;
    }

    let sizeValue = $(`.js-size-attribute[data-display-value="${size}"]`).find('.size-value').attr('data-attr-value');
    let productVariationUrl = $('.js-fit-analytics').attr('data-variation-url');
    let masterProductId = $('.js-fit-analytics').attr('data-master-product-id');
    productVariationUrl = productVariationUrl + `?dwvar_${masterProductId}_color=${itemSubgroupId}&dwvar_${masterProductId}_size=${sizeValue}&pid=${masterProductId}&quantity=1`;

    /* Select color */
    var $this = $(`button.color-attribute[data-value="${itemSubgroupId}"]`);
    if ($this.attr('disabled')) {
        return;
    }
    let $productContainer = $this.closest('.set-item');
    if (!$productContainer.length) {
        $productContainer = $this.closest('.product-detail');
    }

    fitAnalyticsHelper.attributeSelect(productVariationUrl, $productContainer).then(function (data) {

        updatePdpDataObject();

        /* Select size */
        var $this = $(`button.js-size-attribute[data-display-value="${size}"]`);
        let $productContainer = $this.closest('.set-item');

        if (!$productContainer.length) {
            $productContainer = $this.parents('.product-detail');
        }

        fitAnalyticsHelper.attributeSelect(productVariationUrl, $productContainer, true).then(function (data) {
            updatePdpDataObject();
        }).catch(function (err) {
            console.error('Error selecting color attribute from fit analytics:', err);
        });
    }).catch(function (err) {
        console.error('Error selecting color attribute from fit analytics:', err);
    });
}

module.exports = {
    getCookieConsents: getCookieConsents,
    getCurrentSize: getCurrentSize,
    getCartItems: getCartItems,
    addToCart: addToCart,
    selectSize: selectSize,
    updatePdpDataObject: updatePdpDataObject
};
